function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import colors from "styles/colors";
import DesignIcon from "static/svg/templates-store/design_icon.svg";
import CRMIcon from "static/svg/templates-store/sales_and_crm_icon.svg";
import SoftwareIcon from "static/svg/templates-store/software_development_icon.svg";
import PMIcon from "static/svg/templates-store/project_management_icon.svg";
import HRIcon from "static/svg/templates-store/hr_icon.svg";
import MarketingIcon from "static/svg/templates-store/marketing_icon.svg";
import { FEATURED_CATEGORY_CLICKED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import { getSolutionCategoryPageLink } from "template-store/services/solution-links-service";
import Categories from "template-store/constants/categories";
import { getCategoryId } from "template-store/services/solution-categories-service";
import TilesList from "@mondaydotcomorg/monday-ui-components/dist/TilesList";
import { StyledCategoryIdToTileMapping } from "./categories-tiles-component.scss";
const categoryIdToTileMapping = (category)=>{
    const categoryId = getCategoryId(category);
    const tile = {
        [Categories.MARKETING]: {
            background: colors["brand-red"],
            iconRenderer: ()=>/*#__PURE__*/ _jsx(MarketingIcon, {})
        },
        [Categories.PROJECT_MANAGEMENT]: {
            background: colors["brand-yellow"],
            iconRenderer: ()=>/*#__PURE__*/ _jsx(PMIcon, {})
        },
        [Categories.CRM]: {
            background: colors["brand-green"],
            iconRenderer: ()=>/*#__PURE__*/ _jsx(CRMIcon, {})
        },
        [Categories.DESIGN]: {
            background: colors["brand-blue"],
            iconRenderer: ()=>/*#__PURE__*/ _jsx(DesignIcon, {})
        },
        [Categories.SOFTWARE_DEVELOPMENT]: {
            background: colors["brand-purple"],
            iconRenderer: ()=>/*#__PURE__*/ _jsx(SoftwareIcon, {})
        },
        [Categories.HR]: {
            background: colors["brand-turqoise"],
            iconRenderer: ()=>/*#__PURE__*/ _jsx(HRIcon, {})
        }
    }[categoryId];
    return _object_spread_props(_object_spread({
        categoryId
    }, category, tile), {
        link: getSolutionCategoryPageLink(categoryId),
        onClick: ()=>trackEvent(FEATURED_CATEGORY_CLICKED, {
                kind: categoryId
            })
    });
};
const CategoriesTiles = ({ title, categories })=>{
    const categoriesTiles = useMemo(()=>categories.map((category)=>categoryIdToTileMapping(category)), [
        categories
    ]);
    return /*#__PURE__*/ _jsx(StyledCategoryIdToTileMapping, {
        className: "category-tiles-component",
        children: /*#__PURE__*/ _jsx(TilesList, {
            tiles: categoriesTiles,
            title: title
        })
    });
};
export default CategoriesTiles;
